import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { app } from './firebase';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);


// // Express setup
// const express = require('express');
// const app = express();
// const port = process.env.PORT || 5000; // Use port 5000 if no port is specified

// app.get('/', (req, res) => {
//   res.send('Hello from the server!');
// });

// app.listen(port, () => {
//   console.log(`Server is running on port ${port}`);
// });